export const getLanguagesFromConsentTexts = (dataProvider, consentTexts) => {
  let languagesInConsentTexts = mapConsentTextsToLanguagesIds(consentTexts);
  return new Promise((resolve, reject) => {
    dataProvider.getMany('languages', { ids: languagesInConsentTexts })
      .then(languagesResponse => {
        resolve(languagesResponse.data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const mapConsentTextsToLanguagesIds = consentTexts =>
  (consentTexts || []).map(consentText => consentText.language);
